import BiMap from "bidirectional-map";
import { RoutingPaths } from "../../../../shared/enums/routing-paths.enum";

export enum ProgressStep {
  NEEDS_ANALYSIS = "NEEDS_ANALYSIS",
  INSURANCE_VARIANT = "INSURANCE_VARIANT",
  INSURANCE_DATA = "INSURANCE_DATA",
  PAYMENT = "PAYMENT",
  CREATE_POLICY = "CREATE_POLICY",
}

export const progressStepRoutingPathMap = new BiMap<RoutingPaths>({
  [ProgressStep.NEEDS_ANALYSIS]: RoutingPaths.apk,
  [ProgressStep.INSURANCE_VARIANT]: RoutingPaths.variants,
  [ProgressStep.INSURANCE_DATA]: RoutingPaths.insuranceData,
  [ProgressStep.PAYMENT]: RoutingPaths.payment,
  [ProgressStep.CREATE_POLICY]: RoutingPaths.createPolicy,
});
